import React from "react";
import { SvgContainer } from "./style";
const Index = props => {
  return (
    <SvgContainer
      id="svgContent"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      color={props.color}
      size={props.size}
      width={props.size}
      height={props.size}
    >
      <g>
        <path
          d="M23.5 16.997c.28 0 .5.23.5.5 0 .28-.22.5-.5.5H23v-1zM1 16.997h22v1H1z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="M24 5.497v12c0-.27-.22-.5-.5-.5H23v-11.5c0-.27-.22-.5-.5-.5h-6c-.21 0-.39-.12-.46-.3a.501.501 0 0 1 .46-.7h6c.83 0 1.5.68 1.5 1.5zM24 19.497c0 .83-.67 1.5-1.5 1.5h-7.92c-.07-.3-.08-.48-.08-.5 0-.28-.23-.5-.5-.5h8.5c.28 0 .5-.22.5-.5v-1.5h.5c.28 0 .5-.22.5-.5z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="M14.5 20.497c0 .02.01.2.08.5h-1.02c-.06-.29-.06-.48-.06-.5 0-.27.22-.5.5-.5.27 0 .5.22.5.5z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="M9.98 19.997H14c-.28 0-.5.23-.5.5 0 .02 0 .21.06.5h-3.13c.05-.3.05-.48.05-.5 0-.28-.23-.5-.5-.5zM12.5 7.297v.95c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-.95l.5.5z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="M12.5.497v6.8l-.5.5-.5-.5v-6.8c0-.27.22-.5.5-.5s.5.23.5.5zM10.48 20.497c0 .02 0 .2-.05.5H9.41c.07-.29.07-.47.07-.49 0-.28.22-.5.5-.51.27 0 .5.22.5.5z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="m11.65 8.857-2.5-2.5a.48.48 0 0 1-.11-.54c.02-.06.06-.12.11-.17.19-.19.51-.19.7 0l1.65 1.65v.95c0 .28.22.5.5.5s.5-.22.5-.5v-.95l1.65-1.65c.09-.09.22-.14.35-.14s.26.05.35.14c.2.2.2.51 0 .71l-2.5 2.5c-.09.09-.22.14-.35.14s-.26-.05-.35-.14zM10.43 20.997c-.09.46-.3 1.2-.86 2h4.86c-.56-.8-.79-1.54-.87-2h1.02c.12.5.44 1.32 1.27 2.15.15.14.19.36.11.54-.07.19-.26.31-.46.31h-7c-.2 0-.39-.12-.46-.31-.08-.18-.04-.4.11-.54.83-.84 1.14-1.65 1.26-2.15z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="M8.5 10.997h7c.28 0 .5-.22.5-.5v-2c0-.27.22-.5.5-.5s.5.23.5.5v2c0 .83-.67 1.5-1.5 1.5h-7c-.83 0-1.5-.67-1.5-1.5v-2c0-.27.22-.5.5-.5s.5.23.5.5v2c0 .28.22.5.5.5zM1 16.997v1H.5c-.28 0-.5-.22-.5-.5 0-.27.22-.5.5-.5z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="M0 5.497c0-.82.67-1.5 1.5-1.5h6c.28 0 .5.23.5.5 0 .28-.22.5-.5.5h-6c-.28 0-.5.23-.5.5v11.5H.5c-.28 0-.5.23-.5.5zM1 19.497c0 .28.22.5.5.5h8.48a.51.51 0 0 0-.5.51c0 .02 0 .2-.07.49H1.5c-.83 0-1.5-.67-1.5-1.5v-2c0 .28.22.5.5.5H1z"
          fill="#000000"
          opacity="1"
          data-original="#000000"
          className=""
        ></path>
      </g>
    </SvgContainer>
  );
};

export default Index;
